import '../lib/jquery-currency/jquery-currency';
import utils from './utils';
import BasicCalculator from './basic';
import RetirementSavings from './retirement-savings';
import CreditCalculator from './credit-calculator';
import CostOfLoan from './cost-of-loan';
import ValueOfInvestment from './value-of-investment';
import CostOfMortgage from './cost-of-mortgage';
import RuleSeventyTwoCalculator from './rule-of-72';

export default {
    BasicCalculator,
    CostOfLoan,
    CostOfMortgage,
    CreditCalculator,
    init,
    RetirementSavings,
    RuleSeventyTwoCalculator,
    utils,
    ValueOfInvestment
};

//////////

function init() {

    const basicCalculators = document.querySelectorAll('[data-calculator-basic]');
    basicCalculators.forEach( element => {
        new BasicCalculator(element);
    } );

    const CostOfMortgages = document.querySelectorAll('[data-calculator-cost-of-mortgage]');
    CostOfMortgages.forEach( element => {
        new CostOfMortgage(element);
    } );

    const retirementSavings = document.querySelectorAll('[data-calculator-retirement-savings]');
    retirementSavings.forEach( element => {
        new RetirementSavings(element);
    } );

    const CreditCalculators = document.querySelectorAll('[data-calculator-credit-calculator]');
    CreditCalculators.forEach( element => {
        new CreditCalculator(element);
    } );

    const CostOfLoans = document.querySelectorAll('[data-calculator-cost-of-loans]');
    CostOfLoans.forEach( element => {
        new CostOfLoan(element);
    } );

    const ValueOfInvestments = document.querySelectorAll('[data-calculator-value-of-investments]');
    ValueOfInvestments.forEach( element => {
        new ValueOfInvestment(element);
    } );

    const RuleSeventyTwoCalculators = document.querySelectorAll('[data-calculator-rule-seventy-two-calculators]');
    RuleSeventyTwoCalculators.forEach( element => {
        new RuleSeventyTwoCalculator(element);
    } );


}


// WEBPACK FOOTER //
// ./src/calculators/_index.js